import { initSearchBar } from "./search-bar";

/* main */
export const runHome = () => {
  initSearchBar();
};
